/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PersonalizationDto } from './personalizationDto';
import { LoyaltyProgramValueExtractor } from './loyaltyProgramValueExtractor';


export interface LoyaltyProgramDto { 
    id?: number;
    displayName?: string;
    status?: LoyaltyProgramDto.StatusEnum;
    currency?: string;
    priceToPointsRatio?: number;
    pointDecimals?: number;
    govQrCodeAvailable?: boolean;
    dailyLimit?: number;
    logo?: string;
    valueExtractors?: Array<LoyaltyProgramValueExtractor>;
    personalization?: PersonalizationDto;
}
export namespace LoyaltyProgramDto {
    export type StatusEnum = 'INVALID' | 'IN_PROGRESS' | 'VALID';
    export const StatusEnum = {
        Invalid: 'INVALID' as StatusEnum,
        InProgress: 'IN_PROGRESS' as StatusEnum,
        Valid: 'VALID' as StatusEnum
    };
}


